export default {
  setDocumentsLinks: (state, documentsLinks) => {
    documentsLinks.forEach(function(item) {
      if (!state.documentsLinks.includes(item)) {
        state.documentsLinks.push({
          ...item
        });
      }
    });
  }
};
